import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.questionResponseDetail.loading;
export const questionnariesErrorMessage = (state: RootState) =>
  state.questionResponseDetail.error;
export const questionnairesResponseDetailDataResponse = (state: RootState) =>
  state.questionResponseDetail.questionnairesResponseDetailResponse;
